/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_4_AInputs */

const en_mk_faq_4_a = /** @type {(inputs: Mk_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Every outbound action must pass an approval gate — nothing external runs automatically.`)
};

const id_mk_faq_4_a = /** @type {(inputs: Mk_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak. Setiap aksi berdampak keluar wajib lewat gerbang persetujuan — tidak ada aksi eksternal yang jalan otomatis.`)
};

/**
* | output |
* | --- |
* | "No. Every outbound action must pass an approval gate — nothing external runs automatically." |
*
* @param {Mk_Faq_4_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_4_a = /** @type {((inputs?: Mk_Faq_4_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_4_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_4_a(inputs)
	return en_mk_faq_4_a(inputs)
});